import { useState } from 'react';

import { useDidMount } from '@hooks';
import { api } from '@services';

import { useTemplate_landing } from '../useReducer';

export const useConfigList = (initCheck = true) => {
	const [isCheck, setCheck] = useState(!initCheck);
	//
	const { setState } = useTemplate_landing();

	const getConfigLS = () => {
		try {
			return JSON.parse(localStorage.getItem('config-list')) || {};
		} catch (err) {
			return {};
		}
	};
	const setConfigLS = (data = {}) => localStorage.setItem('config-list', JSON.stringify(data));

	useDidMount(() => {
		if (initCheck) checkFetchConfig();
	}, []);

	const checkFetchConfig = async () => {
		await api.$config_fetch_All(
			{
				onOK: (data) => {
					const list = data?.info ?? [];
					const config = list.reduce((result, currenct) => {
						if (currenct.VALUE === 'N') currenct.VALUE = false;
						if (currenct.VALUE === 'Y') currenct.VALUE = true;
						result[currenct.SYMBOL] = currenct;
						return result;
					}, {});

					setConfigLS(config);
					setState({ $config: config });
				},
				onFail: (data) => {
					const config = getConfigLS() || {};
					setState({ $config: config });
				},
				showFailMessage: false,
			},
			{},
		);
		if (!isCheck) setCheck(true);
	};

	return { checkFetchConfig, isCheck };
};
